export default function AboutSection() {
  const highlights = [
    { icon: "ri-user-heart-line", title: "人物关系图鉴", desc: "男主女主、白月光、竹马……核心人物关系一眼看明白。" },
    { icon: "ri-heart-3-line", title: "CP 感情线解析", desc: "主线与支线 CP 逐一拆解，追 CP 走向不再迷路。" },
    { icon: "ri-sparkling-line", title: "细节伏笔考据", desc: "从画面细节出发，帮你看懂作者埋下的每一处线索。" },
    { icon: "ri-team-line", title: "粉丝共建社区", desc: "与同好一起讨论剧情、站队 CP，追漫更有温度。" },
  ];

  const voices = [
    { name: "@晴野永远的神", text: "感情线梳理得超清楚，看完再也不脸盲了，晴野CP入股不亏！" },
    { name: "@追漫不迷路", text: "时间轴把每一阶段的剧情都拆开了，追更完全不会乱，太实用。" },
    { name: "@白月光研究所", text: "伏笔考据那篇真的绝，很多我都没注意到的细节原来都是线索。" },
    { name: "@竹马护卫队", text: "人物介绍很全面，配角线也照顾到了，佐晴党表示很满意。" },
  ];

  return (
    <section id="about" className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2">
          <div>
            <span className="text-sm font-semibold text-primary-600">关于本站</span>
            <h2 className="mt-2 text-2xl font-bold text-foreground-900 md:text-4xl">
              一个专注恋爱辅助器漫画的粉丝内容站
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              我们是一群热爱《恋爱辅助器》的读者，因为被苏晚晴、陆时野之间的互动和一路走来的感情线打动，于是创建了这样一个内容站。
              我们希望用清晰的角色介绍、完整的 CP 关系图和深入的感情线解析，帮助每一位刚入坑或追漫中的朋友，都能快速找到自己想看的内容。
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              {["角色图鉴", "CP 关系", "感情线", "伏笔考据", "追漫攻略"].map((k) => (
                <span key={k} className="rounded-full border border-background-300 bg-background-50 px-3 py-1 text-xs text-foreground-600">
                  {k}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold text-foreground-900">为什么值得关注</h3>
            <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2">
              {highlights.map((h) => (
                <div key={h.title} className="rounded-lg border border-background-200 bg-background-50 p-4">
                  <div className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-100 text-lg text-primary-600">
                    <i className={h.icon}></i>
                  </div>
                  <h4 className="mt-3 text-sm font-bold text-foreground-900">{h.title}</h4>
                  <p className="mt-1 text-xs leading-relaxed text-foreground-600">{h.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-14">
          <h3 className="text-center text-lg font-bold text-foreground-900">读者口碑</h3>
          <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {voices.map((v) => (
              <figure key={v.name} className="rounded-lg border border-background-200 bg-background-50 p-5">
                <div className="flex gap-1 text-accent-400">
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                </div>
                <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">“{v.text}”</blockquote>
                <figcaption className="mt-3 text-xs font-medium text-primary-700">{v.name}</figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}